import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const TableZones = ({ roles }) => {

    return (
        <M_Table entityName={'Zone'} filtersOnTable rolePermissions={roles} />
    )
}